import { IReportRequest } from "../../../model/request/report/IReportRequest";
import { IPagingReportResult } from "../../../model/respone/report/IReportRespone";
import { IReportActionTypes } from "../../action-types/report/IReportActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IReportReducer } from "../../reducer-model/report/IReportReducer";

const iniState: IReportReducer = {
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_not_initialization,
  filerModeReport: "all-co-cong-no",
  filerModeSinhVien: "all",
  reports: {} as IPagingReportResult,
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_hes: [],
    id_khoas: [],
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
    is_co_cong_no: false,
    page_index: 0,
    page_size: 100,
    search_key: "",
    filter_sinhvien: "all",
    filter_congno: "all",
    mau_so: "",
    is_all_hk_namhoc: false,
    id_quoc_tichs: [],
    ky_dang_ky: 0,
    filter_phamvi: "ky",
    id_nhom_thu_chi: 0,
  } as IReportRequest,
  isShowFilter: false,
};
export const reportReducer = (
  state: IReportReducer = iniState,
  action: IReportActionTypes,
): IReportReducer => {
  switch (action.type) {
    case "REPORT_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "REPORT_LOAD_SUCCESS":
      return {
        ...state,
        reports: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_LOAD_ERROR":
      return {
        ...state,
        reports: {} as IPagingReportResult,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_CHANGE_REPORT_FILTER":
      return {
        ...state,
        filerModeReport: action.payload,
        status:
          state.request.is_co_cong_no && action.payload === "all"
            ? eReducerStatusBase.is_need_reload
            : state.status,
        request: {
          ...state.request,
          page_index: 0,
          is_co_cong_no: action.payload !== "all",
        },
      };
    case "REPORT_CHANGE_SINHVIEN_FILTER":
      return {
        ...state,
        filerModeSinhVien: action.payload,
      };
    case "REPORT_CHANGE_REQUEST":
      return {
        ...state,
        reports: {} as IPagingReportResult,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
          ...action.payload,
          page_index: action.payload.hasOwnProperty("page_index")
            ? action.payload["page_index"]
            : 0,
        },
      };
    case "REPORT_SHOW_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: true,
        idSinhVien: action.payload,
      };
    case "REPORT_CLOSE_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: false,
      };
    case "REPORT_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    case "REPORT_EXPORT_EXCEL_BAO_CAO_START":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_loading,
      };
    case "REPORT_EXPORT_EXCEL_BAO_CAO_SUCCESS":
    case "REPORT_EXPORT_EXCEL_BAO_CAO_ERRR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
